import dayjs from 'dayjs'

export const formatEmploymentDateForApi = (value: dayjs.ConfigType) => {
    if (!value) return null
    const parsed = dayjs(value)
    return parsed.isValid() ? parsed.format('YYYY-MM-DDT00:00:00') : null
}
